import { BaseWebComponentController } from '../../../../../../../../framework/BaseWebComponentController';
import { PatchesGridWebComponent } from '../../patchesGrid';
import { ProductsGridWebComponent } from '../component/ProductsGridWebComponent';
import { ProductsGridView } from '../view/ProductsGridView';
import { templateProductsGrid } from '../view/template';

export class ProductsGridController extends BaseWebComponentController {
  public component: ProductsGridWebComponent;
  public view: ProductsGridView;
  public viewConstructor: typeof ProductsGridView;

  constructor(component: PatchesGridWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: ProductsGridView,
      viewTemplate: templateProductsGrid,
    });
  }

  injectDependencies(dependencies) {
    super.injectDependencies(dependencies);

    this.view.patchId = this.component.patchId;
    this.view.productsCount = this.component.productsCount;
  }
}
